import Vue from 'vue';

Vue.filter('lowercase', function (value) {
    if (!value) return '';
    return value.toLowerCase()
});